import 'mint-ui/lib/style.css';
import '@/font/iconfont.css';
import './styles/global-style.css'
//import 'mescroll.js/mescroll.min.css'
//import 'swiper/dist/css/swiper.css'

import Vue from 'vue'
import App from './App'
import Mint from 'mint-ui';
import store from './store'
import router from './router'

import './validator/validate.js'
//import component from './components/lib/index.js'

Vue.use(Mint);
//Vue.use(component);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if(to.path == '/login' || to.path == '/ddLogin') {
		sessionStorage.removeItem('user');
		sessionStorage.removeItem('token');
		sessionStorage.removeItem('roles');
		sessionStorage.removeItem('perms');
	}
	let user = sessionStorage.getItem('user');
//	/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
	if(!user){
		if(!to.path.startsWith("/login") && !to.path.startsWith("/ddLogin")){
		    next({ path: '/ddLogin', query: {path: to.path, query: JSON.stringify(to.query)}});
		}else{
			next();
		}
	}else{
		next();
	}
//	let query = to.query;
//	if(to.path != '/ddLogin' && !query.dd_nav_bgcolor){
//		query.dd_nav_bgcolor = 'FF5E97F6';
//		next({ path: to.path, query: query });
//	}else{
//		next();
//	}
    next();  

//	if(to.path == '/ddLogin') {
//		sessionStorage.removeItem('user');
//		sessionStorage.removeItem('token');
//		sessionStorage.removeItem('roles');
//		sessionStorage.removeItem('perms');
//	}
//	let user = sessionStorage.getItem('user');
//	if(!user && !to.path.startsWith("/ddLogin")) {
//	} else {
//		next();
//	}

});

//自定义指令  
Vue.directive('hasPerm', {
	bind: function(el, binding, vnode) {
		let value = binding.value;
		let perms = JSON.parse(sessionStorage.getItem("perms"));
		let roles = JSON.parse(sessionStorage.getItem("roles"));
		let has = false;

		has = (perms.indexOf(value) == -1 ? false : true);
		if(!has) {
			has = (roles.indexOf(value) == -1 ? false : true);
		}
		if(has) {
			el.style.display = "inline";
		} else {
			el.style.display = "none";
		}
	}
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js